"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboxes = exports.Checkbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    text-align: left;\n    margin: 0 10px 5px;\n    @media (max-width: 767px) {\n        margin-right: 0;\n    }\n    input {\n        display: none;\n        &:checked+label {\n            &:before {\n                transform: rotate(45deg);\n                top: 18px;\n                left: -27px;\n                width: 2px;\n                height: 2px;\n                border-width: 0;\n            }\n            &:after {\n                top: -5px;\n                left: -28px;\n                width: 12px;\n                height: 24px;\n                border: 2px solid ", ";\n                border-top: 0;\n                border-left: 0;\n                transform: rotate(45deg);\n                transition-delay: 140ms;\n            }\n        }\n        :disabled, :disabled + label {\n            cursor: not-allowed;\n        }\n    }\n    label {\n        position: relative;\n        display: inline-block;\n        margin: 6px 20px 3px 36px;\n        line-height: 30px;\n        cursor: pointer;\n        user-select: none;\n        transition: color 140ms ease-out;\n        &:before {\n            content: \" \";\n            position: absolute;\n            display: inline-block;\n            top: 0;\n            left: -35px;\n            width: 21px;\n            height: 21px;\n            border: solid 2px;\n            margin-top: 3px;\n            border-radius: 2px;\n            border-color: rgba(121,121,121,.8);\n            transition: all 280ms ease-out,transform 140ms ease-out;\n        }\n        &:after {\n            content: \" \";\n            position: absolute;\n            display: inline-block;\n            top: 17px;\n            left: -27px;\n            width: 2px;\n            height: 2px;\n            border: 2px solid transparent;\n            transform: rotate(0deg);\n            transition: all 140ms ease-out;\n        }\n        @media (max-width: 767px) {\n            margin-right: 0;\n        }\n    }\n    &.is-audit {\n        input {\n            :checked+label {\n                color: #549E38;\n                &:after {\n                    box-shadow: none;\n                    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'%3E%3Cpath d='M16.0313 3.83984H14.8025C14.6303 3.83984 14.4668 3.91895 14.3613 4.0543L7.11388 13.2354L3.63868 8.83203C3.58611 8.76528 3.5191 8.71131 3.44269 8.67417C3.36627 8.63703 3.28243 8.61768 3.19747 8.61758H1.96876C1.85099 8.61758 1.78595 8.75293 1.85802 8.84434L6.67267 14.9439C6.89767 15.2287 7.33009 15.2287 7.55685 14.9439L16.142 4.06484C16.2141 3.9752 16.149 3.83984 16.0313 3.83984Z' fill='%23549E38'/%3E%3C/svg%3E\");\n                    background-repeat: no-repeat;\n                    background-position: center;\n                    background-color: transparent;\n                    transform: none;\n                    border: 0;\n                    background-size: contain;\n                    width: 21px;\n                    height: 24px;\n                    top: 2px;\n                    left: -33px;\n                }\n            }\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledCheckbox = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var colors = _ref.colors;
  return colors.input || '#f54d2e';
});

var CheckboxComponent = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxComponent, _Component);

  var _super = _createSuper(CheckboxComponent);

  function CheckboxComponent() {
    var _this;

    _classCallCheck(this, CheckboxComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      return _this.props.onChange(e.target.checked);
    });

    return _this;
  }

  _createClass(CheckboxComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$input = _this$props.input,
          name = _this$props$input.name,
          value = _this$props$input.value,
          text = _this$props.text,
          colors = _this$props.colors,
          isAudit = _this$props.isAudit;
      return /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
        colors: colors
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: name,
        type: "checkbox",
        checked: !!value,
        onChange: this.onChange
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: name
      }, (0, _ramda.is)(Function, text) ? text(this.props) : text));
    }
  }]);

  return CheckboxComponent;
}(_react.Component);

_defineProperty(CheckboxComponent, "defaultProps", {
  colors: {}
});

var CheckboxesComponent = /*#__PURE__*/function (_Component2) {
  _inherits(CheckboxesComponent, _Component2);

  var _super2 = _createSuper(CheckboxesComponent);

  function CheckboxesComponent() {
    var _this2;

    _classCallCheck(this, CheckboxesComponent);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "onChange", function (value) {
      var _this2$props = _this2.props,
          values = _this2$props.input.value,
          onChange = _this2$props.onChange;
      onChange((0, _ramda.contains)(value, values || []) ? (0, _ramda.without)([value], values) : (0, _ramda.append)(value, values));
    });

    return _this2;
  }

  _createClass(CheckboxesComponent, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          _this$props2$input = _this$props2.input,
          name = _this$props2$input.name,
          value = _this$props2$input.value,
          namePath = _this$props2.namePath,
          valuePath = _this$props2.valuePath,
          colors = _this$props2.colors,
          disabled = _this$props2.disabled;
      return options.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
          className: _this3.props.isAudit ? 'is-audit' : '',
          key: "".concat(name, "-").concat(index),
          colors: colors
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: "".concat(name, "-").concat(index),
          type: "checkbox",
          onChange: function onChange() {
            return _this3.onChange(option[valuePath]);
          },
          checked: (0, _ramda.contains)(option[valuePath], value || []),
          disabled: disabled
        }), /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: "".concat(name, "-").concat(index)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          dangerouslySetInnerHTML: {
            __html: option[namePath]
          }
        })));
      });
    }
  }]);

  return CheckboxesComponent;
}(_react.Component);

_defineProperty(CheckboxesComponent, "defaultProps", {
  options: [],
  namePath: 'name',
  valuePath: 'id',
  colors: {},
  isAudit: false
});

var Checkbox = (0, _withFieldWrapper["default"])(CheckboxComponent);
exports.Checkbox = Checkbox;
var Checkboxes = (0, _withFieldWrapper["default"])(CheckboxesComponent);
exports.Checkboxes = Checkboxes;